var React = require('react');

function Bell (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/bell"},React.createElement("path",{"id":"Icon Stroke","d":"M9.5 18V18.5C9.5 19.8807 10.6193 21 12 21C13.3807 21 14.5 19.8807 14.5 18.5V18M18 9V12C18 13.7416 18.8348 15.2233 20 15.7724V18H4V15.7724C5.16519 15.2233 6 13.7416 6 12V9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9Z","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Bell.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bell;

Bell.default = Bell;
